<template>
    <div>
        <div class="block">
            <span>là</span>
            <!-- <span @click="clickTest()">{{ namePresta }}</span> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'PrestationsForm',
    props: ['prestation'],
    data: function () {
        return {
            index: 0,
            test: 0,
            namePresta: this.prestation.name,
        }
    },

    methods: {
        clickTest() {
            this.namePresta = 'bonjour'
        },
    },
}
//     deletePrestation(index) {
//       this.question.answers_possibilities.splice(index, 1)
//       this.$forceUpdate()
//       console.log(this.question.answers_possibilities)
//     },

//     showPrestation() {
//       this.question.is_in_customer_card = !this.question.is_in_customer_card
//       this.$forceUpdate()
//       console.log(this.question.is_in_customer_card)
//     },

//     deletePrestation() {
//       this.$emit('delete-event', this.identifier)
//     },
//   },
</script>
